export const extraServicesData = [
    {
      key: "1",
      NAME: "Child Seats",
      PRICE: "$120",
      TYPE: "One Time",
      NOOFCARS: "12",
      STATUS: "Active",
    },
    {
      key: "2",
      NAME: "GPS Navigation System",
      PRICE: "$30",
      TYPE: "Per Day",
      NOOFCARS: "12",
      STATUS: "Active",
    },
    {
      key: "3",
      NAME: "Roof Box Storage",
      PRICE: "$100",
      TYPE: "One Time",
      NOOFCARS: "15",
      STATUS: "Active",
    },
    {
      key: "4",
      NAME: "Camping Equipment",
      PRICE: "$130",
      TYPE: "One Time",
      NOOFCARS: "8",
      STATUS: "Active",
    },
    {
      key: "5",
      NAME: "Glass & Tire Protection",
      PRICE: "$150",
      TYPE: "One Time",
      NOOFCARS: "16",
      STATUS: "Inactive",
    },
    {
      key: "6",
      NAME: "Mini Refrigerator",
      PRICE: "$80",
      TYPE: "One Time",
      NOOFCARS: "22",
      STATUS: "Inactive",
    },
    {
      key: "7",
      NAME: "Wi-Fi Hotspot",
      PRICE: "$30",
      TYPE: "Per Day",
      NOOFCARS: "10",
      STATUS: "Active",
    },
    {
      key: "8",
      NAME: "Express Check-in/Check-out",
      PRICE: "$200",
      TYPE: "One Time",
      NOOFCARS: "25",
      STATUS: "Active",
    },
    {
      key: "9",
      NAME: "Air Purifier",
      PRICE: "$40",
      TYPE: "Per Day",
      NOOFCARS: "25",
      STATUS: "Inactive",
    },
    {
      key: "10",
      NAME: "Sanitization Kit",
      PRICE: "$60",
      TYPE: "One Time",
      NOOFCARS: "18",
      STATUS: "Active",
    },
];